import { useState } from 'react';
import { useElements, useStripe } from '@stripe/react-stripe-js';
import classNames from 'classnames';

import getCardIcon from 'util/getCardIcon';

import ConfirmModal from 'components/modals/ConfirmModal/ConfirmModal';
import WrappedApplePayButton from 'components/WrappedApplePayButton';
import WrappedGooglePayButton from 'components/WrappedGooglePayButton';
import AddCard from './AddCard';
import AddACH from './AddACH';

const SavedPaymentMethods = ({
  walletStore,
  addFundsGiftCheckoutStore,
  userId,
  cards = [],
  isCheckout,
}) => {
  const [showAddCard, setShowAddCard] = useState(false);
  const [cardForRemoval, setCardForRemoval] = useState(null);
  const elements = useElements();
  const stripe = useStripe();

  const handleRemoveCard = () => {
    walletStore.removeCard({
      userContext: { userId },
      cardId: cardForRemoval.id,
    });
  };

  return (
    <>
      <ConfirmModal
        isOpen={Boolean(cardForRemoval)}
        action={handleRemoveCard}
        onToggleClose={() => setCardForRemoval(null)}
        message="Delete Payment Method"
        bodyMessage={`Are you sure want to delete ${
          cardForRemoval?.brand || 'card'
        } ending in ${cardForRemoval?.last4}?`}
        confirmOnly={true}
      />
      <div className="saved-payment-methods">
        {cards.map((card) => (
          <div className="saved-payment-method">
            <div
              className={classNames('uapm-name', {
                '!text-gray-400': card.isDisabled,
              })}
            >
              <span>{card.name || card.brand}</span>
              {card.isDisabled && (
                <span className="text-red-400 ml-4">
                  {card.stripeCardId.includes('card_')
                    ? 'RE-ADD CARD'
                    : 'EXPIRED'}
                </span>
              )}
            </div>
            <div className="uapm-brand-container">
              <div className="uapm-brand">
                <img src={getCardIcon(card.brand)} />
              </div>
              <div
                className={classNames('uapm-last4', {
                  '!text-gray-400': card.isDisabled,
                })}
              >
                *{card.last4}
              </div>
              {card.isDefault && !card.isDisabled ? (
                <button disabled className="uapm-default-btn is-default">
                  DEFAULT
                </button>
              ) : (
                <button
                  className="uapm-default-btn disabled:!bg-gray-200 disabled:!text-gray-500 disabled:!border-none"
                  disabled={card.isDisabled}
                  onClick={() => {
                    walletStore.updateDefaultCard({
                      cardId: card.id,
                      userContext: { userId },
                    });
                  }}
                >
                  SET AS DEFAULT
                </button>
              )}
              <button
                className="delete uapm-x-btn"
                onClick={() => {
                  setCardForRemoval(card);
                }}
              >
                X
              </button>
            </div>
          </div>
        ))}
        <div className="saved-payment-button-container">
          <AddCard
            isDetails
            isCheckout={isCheckout}
            showAddCard={showAddCard}
            setShowAddCard={setShowAddCard}
            onAddCard={() => {
              if (showAddCard) {
                walletStore
                  .registerNewCard({
                    elements: elements,
                    stripe: stripe,
                    userContext: {
                      userId,
                    },
                  })
                  .then((success) => success && setShowAddCard(false));
              } else {
                setShowAddCard(true);
              }
            }}
          />
          <AddACH
            userId={userId}
            store={isCheckout ? addFundsGiftCheckoutStore : walletStore}
          />
          {isCheckout && (
            <>
              {Boolean(window.ApplePaySession) ? (
                <WrappedApplePayButton store={addFundsGiftCheckoutStore} />
              ) : (
                <WrappedGooglePayButton store={addFundsGiftCheckoutStore} />
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SavedPaymentMethods;
